<template>
  <div
    class="dui-notification"
    :class="type"
  >
    {{ message }}
  </div>
</template>

<script>
export const NOTIFICATION_TYPES = Object.freeze({
  error: 'error',
  message: 'message',
  success: 'success',
});

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.dui-notifications-panel {
  display: flex;
  flex-direction: column;
  pointer-events: none;
  position: fixed;
  right: $_4em;
  top: $_3em;
  width: $notification-panel-width;
  z-index: $z-index-notification-panel;

  @include screenLessThan(sm) {
    left: $_2em;
    right: initial;
    width: calc(100% - #{ $_4em });
  }

  .dui-notification {
    animation-duration: $transition-time-base;
    animation-fill-mode: forwards;
    animation-name: default-appear;
    background-color: getColor($white);
    border-radius: $border-radius-base;
    border: $border-width-base solid getColor($grey, fade);
    box-shadow: $box-shadow-panel;
    font-weight: $base-weight-bold;
    margin-top: $_1em;
    opacity: 0;
    padding: $_1em $_2em;

    &.closing {
      animation-name: default-disappear;
    }

    &.error {
      background-color: getColor($red);
      border: none;
      color: getColor($white);
    }

    &.success {
      background-color: getColor($yellow);
      border: none;
      color: getColor($white);
    }
  }
}
</style>
